import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Callout } from "../components/Callout.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Callout mdxType="Callout">
  **Check your plan:** This course includes features that are only available on
  the following GraphOS plans: Developer, Standard, or Enterprise.
    </Callout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      